import { Controller } from "stimulus";

export default class extends Controller {
  showLineItemRule() {
    $('#line-item-rule-form').show();
    $('#invoice-rule-form').hide();

    const controller = this;
    setTimeout(() => {
      const conditionsElement = document.querySelector('#line-item-rule-form [data-controller="pricing-rules-conditions"]');
      const conditionsController = controller.application.getControllerForElementAndIdentifier(conditionsElement, "pricing-rules-conditions");
      if (conditionsController) {
        conditionsController.setOperators();
      }
    }, 300);
  }

  showInvoiceRule() {
    $('#invoice-rule-form').show();
    $('#line-item-rule-form').hide();

    const controller = this;
    setTimeout(() => {
      const conditionsElement = document.querySelector('#invoice-rule-form [data-controller="pricing-rules-conditions"]');
      const conditionsController = controller.application.getControllerForElementAndIdentifier(conditionsElement, "pricing-rules-conditions");
      if (conditionsController) {
        conditionsController.setOperators();
      }
    }, 300);
  }
}
